import React from 'react';
import KpiGrid from '../components/KpiGrid';
import TrafficTimelineChart from '../components/TrafficTimelineChart';
import MnoDonutChart from '../components/MnoDonutChart';
import FlowFunnelView from '../components/FlowFunnelView';
import { useTelemetry } from '../context/TelemetryContext';

export default function OverviewView(props) {
  const telemetry = useTelemetry();
  const summary = props.summary ?? telemetry.summary;
  const timeline = props.timeline ?? telemetry.timeline;
  const mno = props.mno ?? telemetry.mno;
  const route = props.route ?? telemetry.route;
  const forceMock = props.forceMock ?? telemetry.forceMock;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      
      {/* 1. Executive Top Metrics */}
      <KpiGrid summary={summary} />

      {/* 2. Real-Time Concurrency Chart & MNO Donut */}
      <div className="two-col-grid">
        <TrafficTimelineChart timeline={timeline} />
        <MnoDonutChart summary={summary} />
      </div>

      {/* 3. Primary User Flow Funnel Preview */}
      <FlowFunnelView mno={mno} route={route} forceMock={forceMock} />

    </div>
  );
}
